import Marquee from "react-fast-marquee";

const ITEMS = [
  "SYS_LOG_9402",
  "PRESSURE_DROP_DETECTED",
  "SENSOR_T99_ANOMALY",
  "OVERRIDE_ENGAGED",
  "PSV-402 FAIL-TO-OPEN",
  "MOC-2231 OPEN",
  "THERMAL_FATIGUE_HAZ",
  "V-402A BYPASS 40%",
  "CALIBRATION_DRIFT −43°C",
  "LOPC-2 CONTAINMENT",
];

export default function Ticker() {
  return (
    <div className="relative border-y border-white/10 bg-[#152430] py-4 overflow-hidden">
      <Marquee speed={38} gradient gradientColor="#152430" gradientWidth={120} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center font-mono-data text-xs tracking-[0.25em] text-zinc-500 mx-8">
            <span className="w-1.5 h-1.5 bg-[#b88457] mr-8" />
            {t}
          </div>
        ))}
      </Marquee>
    </div>
  );
}
